// Golf Match Play Tracker 2026 -- Formatting

// Handicap index is stored signed: negative = plus handicap.
// -1.5 -> "+1.5"   |   8.1 -> "8.1"   |   null -> "--"
export function formatHandicap(h) {
  if (h === null || h === undefined || h === "") return "--";
  const n = Number(h);
  if (Number.isNaN(n)) return "--";
  if (n < 0) return `+${Math.abs(n).toFixed(1)}`;
  return n.toFixed(1);
}

// Course handicap can also be negative (a plus player gives strokes).
export function formatCourseHandicap(ch) {
  if (ch === null || ch === undefined) return "--";
  if (ch < 0) return `+${Math.abs(ch)}`;
  return `${ch}`;
}

// Parse user input "+1.5" or "-1.5" or "1.5" into the signed storage value.
// A leading "+" means a plus handicap -> stored negative.
export function parseHandicapInput(raw) {
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim();
  if (s === "") return null;
  if (s.startsWith("+")) {
    const n = Number(s.slice(1));
    return Number.isNaN(n) ? null : -Math.abs(n);
  }
  const n = Number(s);
  return Number.isNaN(n) ? null : n;
}

export function pluralize(n, one, many) {
  return `${n} ${n === 1 ? one : many}`;
}
